import { BaseService } from '@services/BaseService';

class LogService extends BaseService {
  constructor() {
    super('util');
  }

  logError(message: string, innerMessage: string) {
    return this.fetch('exception', {
      method: 'POST',
      body: JSON.stringify({ message, innerMessage })
    });
  }
}

export const logService = new LogService();



// WEBPACK FOOTER //
// ./src/_services/LogService.ts